import { createContext } from 'react';
import { observable, makeObservable, action } from 'mobx';

export class ThemeStore {
  constructor() {
    this.typography = {};

    makeObservable(this, {
      typography: observable,
      setTypography: action,
    });
  }

  setTypography(newTypography) {
    this.typography = newTypography;
  }
}

export const ThemeContext = createContext();
